import { render, staticRenderFns } from "./UsgsHeader.vue?vue&type=template&id=3d668fb8&scoped=true&"
var script = {}
import style0 from "./UsgsHeader.vue?vue&type=style&index=0&id=3d668fb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d668fb8",
  null
  
)

export default component.exports